import React from 'react';
import $ from 'jquery';

class ContactForm extends React.Component {
  constructor() {
    super()
    this.handleContact = this.handleContact.bind(this)
  }

  handleContact = (e) => {
    $('#contactForm').submit(false)
    $('#success').text('Thank you. Your message was submitted')
    e.preventDefault()
    e.stopPropagation()
    return false
  }

  render() {
    return (
      <form id="contactForm" onSubmit={this.handleContact}>
            <div className="row control-group">
                <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label>Name</label>
                    <input type="text" className="form-control" placeholder="Name" id="name" required />
                    <p className="help-block text-danger"></p>
                </div>
            </div>
            <div className="row control-group">
                <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label>Email Address</label>
                    <input type="email" className="form-control" 
                        id="email" 
                        required placeholder="e.g. binary@bo.com" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z0-9]{2,3}$" />
                    <p className="help-block text-danger"></p>
                </div>
            </div>
            <div className="row control-group">
                <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label>Phone Number</label>
                    <input type="tel" className="form-control" placeholder="e.g. xxxx-xxx-xxxx" id="phone" required pattern="^\d{4}-\d{3}+\w-\d{4}$" />
                    <p className="help-block text-danger"></p>
                </div>
            </div>
            <div className="row control-group">
                <div className="form-group col-xs-12 floating-label-form-group controls">
                    <label>Message</label>
                    <textarea rows="5" className="form-control" placeholder="Message" id="message" required data-validation-required-message="Please enter a message." ></textarea>
                    <p className="help-block text-danger"></p>
                </div>
            </div>
            <div id="success" className="msg"></div>
            <div className="row">
                <div className="form-group col-xs-12">
                    <button type="submit" className="btn btn-default">Send</button>
                </div>
            </div>
        </form>
    )
  }
}

export default ContactForm


// WEBPACK FOOTER //
// ./src/components/pages/Contact/ContactForm.js